module.exports = __webpack_public_path__ + "static/footer.6386f10e676d5059710303230023e86c.png";